//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { CustomFieldValueInputItem } from './CustomFieldValueInputItem';
import { CustomFieldType } from './Enums';

export class CustomFieldRadioListValueInputItem extends CustomFieldValueInputItem {
    Option: string | null = null;
    override readonly FieldType: CustomFieldType = CustomFieldType.RadioList;

    constructor(initializer?: Partial<Omit<CustomFieldRadioListValueInputItem, "FieldType">>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "CustomFieldRadioListValueInputItem";
}
